// extracted by mini-css-extract-plugin
module.exports = {"navFooterContainer":"news-article-module--nav-footer-container--36UO5","pageWrapper":"news-article-module--page-wrapper--2qRo-"};